// extracted by mini-css-extract-plugin
module.exports = {"container":"ckPbQC mz-interactive-info-block--white","loading":"_2UOgrL"};